// The fourteen tables, and who may change each.

import { Link } from 'react-router-dom';
import { COLLECTIONS } from '../schema';
import { Screen } from '../shell/Screen';
import { useMe } from '../data';

export function DataIndexScreen() {
  const me = useMe();
  return (
    <Screen
      title="Tables"
      description="Every table in the application. Reads are open to everyone signed in; reference data is Admin-write."
    >
      <ul className="table-index">
        {Object.values(COLLECTIONS).map((collection) => (
          <li key={collection.slug}>
            <Link to={`/data/${collection.slug}`}>{collection.label}</Link>
            <span className="muted">
              {collection.writeRole === 'Admin'
                ? me.data?.is_admin
                  ? 'Admin — you may change this'
                  : 'Admin — read only for you'
                : 'Anyone signed in may change this'}
            </span>
          </li>
        ))}
      </ul>
    </Screen>
  );
}
